import { PAGE_CODES } from 'constants/pageCodes';
import { lazyWithRetry } from 'utils/chunkLoadRecovery';
import { EnhancedPath } from 'utils/history';

export class RealtorsPaths {
  static realtors = new EnhancedPath('/realtors');
}

const routesConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: RealtorsPaths.realtors.path,
      component: lazyWithRetry(() => import('app/pages/system/realtors')),
      pageCode: PAGE_CODES.REALTORS,
    },
  ],
};

export default routesConfig;
